import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

import { websiteUrl } from "@constants";

import type { IFooterLinkGroup, ISocialLink } from "./Footer.types";

export const footerLinkGroups: IFooterLinkGroup[] = [
  {
    titleKey: "footerV2.practiceAreas.title",
    links: [
      { labelKey: "footerV2.practiceAreas.familyAndInheritance", href: `${websiteUrl}/familie-arv` },
      { labelKey: "footerV2.practiceAreas.housing", href: `${websiteUrl}/bolig` },
      { labelKey: "footerV2.practiceAreas.business", href: `${websiteUrl}/erhverv` },
      { labelKey: "footerV2.practiceAreas.estateAdministration", href: `${websiteUrl}/dodsbobehandling` },
    ],
  },
  {
    titleKey: "footerV2.company.title",
    links: [
      { labelKey: "footerV2.company.about", href: `${websiteUrl}/om-os` },
      { labelKey: "footerV2.company.prices", href: `${websiteUrl}/priser` },
      { labelKey: "footerV2.company.articles", href: `${websiteUrl}/artikler` },
      { labelKey: "footerV2.company.career", href: `${websiteUrl}/karriere` },
      { labelKey: "footerV2.company.contact", href: `${websiteUrl}/kontakt` },
      { labelKey: "footerV2.company.press", href: `${websiteUrl}/presse` },
    ],
  },
  {
    titleKey: "footerV2.policies.title",
    links: [
      { labelKey: "footerV2.policies.privacyCustomers", href: `${websiteUrl}/privatlivspolitik-for-kunder` },
      { labelKey: "footerV2.policies.privacyApplicants", href: `${websiteUrl}/privatlivspolitik-for-ansogere` },
      { labelKey: "footerV2.policies.terms", href: `${websiteUrl}/vilkar-og-betingelser` },
      { labelKey: "footerV2.policies.cookies", href: `${websiteUrl}/cookiepolitik` },
    ],
  },
];

export const socialLinks: ISocialLink[] = [
  { label: "LinkedIn", urlKey: "global.contactInfo.linkedinUrl", icon: LinkedInIcon },
  { label: "Facebook", urlKey: "global.contactInfo.facebookUrl", icon: FacebookIcon },
];
